import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';

const secondaryNavTitle = "_secondary-nav-title_1uwk4_1";
const styles = {
	secondaryNavTitle: secondaryNavTitle
};

const SecondaryNavTitle = ({ value, className }) => {
  return jsx("h2", { className: clsx(className, styles.secondaryNavTitle), "data-zds": true, children: value });
};

export { SecondaryNavTitle };
//# sourceMappingURL=SecondaryNavTitle.es.js.map
